class LoggerConsoleConnector
{

    /** @param {Timer} timer */
    constructor(timer) {
        this._timer = timer;
    }

    _getTime()
    {
        return this._timer.getTime().toFixed(3);
    }

    log(source, level, message, context)
    {
        console.log(
            this._getTime() + ' | ' + source.toUpperCase() + '.' + level.toUpperCase() + ' | ' + message
        );
        if (typeof context !== 'undefined') {
            console.dir(context);
        }
    }

}

export default LoggerConsoleConnector;